import { useState, useEffect, Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";


//conditional wrapper component
const ConditionalWrapper = ({ initialWrapper, condition, wrapper, children }) =>
  condition ? wrapper(children) : initialWrapper(children);

//tabs component
export const Tabs = ({ activeTab, tabsList, isFancyTabs = true, isVertical }) => {
    const navigate = useNavigate();
  const location = useLocation(),
    [isUrlTabs, setIsUrlTabs] = useState(false),
    [currentActiveTab, setCurrentActiveTab] = useState();
    // console.log(history)
  useEffect(() => {
    if (tabsList.find((el) => el.tabUrl)) {
      setIsUrlTabs(true);
    } else {
      if (activeTab !== 0 && activeTab && activeTab < tabsList.length) {
        setCurrentActiveTab(activeTab);
      } else {
        setCurrentActiveTab(0);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isUrlTabs) {
      const currentActiveTabUrlIndex = tabsList.findIndex(
        (el) => el.tabUrl === location.pathname
      );
      setCurrentActiveTab(currentActiveTabUrlIndex !== -1 ? currentActiveTabUrlIndex : 0);
    }
    // eslint-disable-next-line
  }, [location.pathname, isUrlTabs]);

  const onChangeTab = (index, tabUrl) => {
    if (tabUrl) navigate(tabUrl);
    else setCurrentActiveTab(index);
  };

  return (
    <div className={`tabs ${isVertical ? 'vertical-tabs' : ''}`}>
    <div className={`${isFancyTabs ? 'fancy-labels-wrapper' : 'labels-wrapper'}`}>
      <div className="labels">
        {tabsList.map((el, i) => (
          <div
            className={'tab-label' + (currentActiveTab === i ? ' active-tab-label' : '')}
            key={i}
            onClick={() => {
              onChangeTab(i, el.tabUrl);
            }}
          >
            {el.label}
          </div>
        ))}
      </div>
    </div>
    <div className="tabs-content-wrapper" style={{ borderRadius: isFancyTabs ? 10 : 0 }}>
      {tabsList.map((el, i) => (
        <div
          style={{
            padding: "1.5rem",
            display: currentActiveTab === i ? 'block' : 'none',
          }}
          className={'tab-content' + (currentActiveTab === i ? ' active-tab-content' : '')}
          key={i}
        >
          {el.content}
        </div>
      ))}
    </div>
  </div>
  
  );
};